import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route,Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts.css';
import './App.css';
import MainLayout from './layouts/main';
import themeService from './services/ThemeService';

import SignIn from './pages/Authentication/SignIn';
import SignUp from './pages/Authentication/SignUp';
import Dashboard from './pages/Dashboard/Dashboard';
import ForgotEmail from './pages/Authentication/ForgotEmail';
import ForgotPassword from './pages/Authentication/ForgotPassword';
import ChangePassword from './pages/Authentication/ChangePassword';
import VerifyOTP from './pages/Authentication/VerifyOTP';
import EmailVerification from './pages/Authentication/EmailVerification';
import AdminDashboard from './pages/Dashboard/AdminDashboard';
import HomeWidgets from './pages/Home/HomeWidgets';
import AboutUs from './pages/AboutUs/AboutUs';
import Products from './pages/Products/Products';
import Automation from './pages/Automation/Automation';
import Support from './pages/Support/Support';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import CookieSettings from './components/common/CookieSettings';
import TermsAndConditions from './pages/TermsAndConditions/Terms&Conditions';
import Profile from './pages/Profile/Profile';
import SecurityPage from './pages/Profile/ProfileSecurity';
import EventSharing from './pages/Event/EventSharing';
import { ToastContainer } from "react-toastify";
import ZoomCallback from './pages/VideoConference/Callbacks/ZoomCallback';
import GoogleCallback from './pages/VideoConference/Callbacks/GoogleCallback';
import ZoomIntegrationGuide from './pages/ZoomIntegrationGuide/ZoomIntegrationGuide';

const token = localStorage.getItem("accessToken");


function App() {
  // Initialize theme on app start
  useEffect(() => {
    themeService.setTheme('Default');
  }, []);

  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              token ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/home" replace />
              )
            }
          />
          <Route
            path="/home"
            element={
              <MainLayout>
                <HomeWidgets />
              </MainLayout>
            }
          />
          <Route
            path="/signin"
            element={
              <MainLayout>
                <SignIn />
              </MainLayout>
            }
          />
          <Route
            path="/signup"
            element={
              <MainLayout>
                <SignUp />
              </MainLayout>
            }
          />

          <Route
            path="/dashboard"
            element={
              <MainLayout>
                <Dashboard />
              </MainLayout>
            }
          />

          <Route
            path="/forgotemail"
            element={
              <MainLayout>
                <ForgotEmail />
              </MainLayout>
            }
          />

          <Route
            path="/forgotpassword"
            element={
              <MainLayout>
                <ForgotPassword />
              </MainLayout>
            }
          />

          <Route
            path="/verifyotp"
            element={
              <MainLayout>
                <VerifyOTP />
              </MainLayout>
            }
          />

          <Route
            path="/changepassword"
            element={
              <MainLayout>
                <ChangePassword />
              </MainLayout>
            }
          />

          <Route
            path="/emailverification"
            element={
              <MainLayout>
                <EmailVerification />
              </MainLayout>
            }
          />

          <Route
            path="/about"
            element={
              <MainLayout>
                <AboutUs />
              </MainLayout>
            }
          />

          <Route
            path="/products"
            element={
              <MainLayout>
                <Products />
              </MainLayout>
            }
          />

          <Route
            path="/privacy-policy"
            element={
              <MainLayout>
                <PrivacyPolicy />
              </MainLayout>
            }
          />

          <Route
            path="/terms-and-conditions"
            element={
              <MainLayout>
                <TermsAndConditions />
              </MainLayout>
            }
          />

          <Route
            path="/zoom-integration-guide"
            element={
              <MainLayout>
                <ZoomIntegrationGuide />
              </MainLayout>
            }
          />

          <Route
            path="/cookie-settings"
            element={
              <MainLayout>
                <CookieSettings />
              </MainLayout>
            }
          />

          <Route
            path="/support"
            element={
              <MainLayout>
                <Support />
              </MainLayout>
            }
          />

          <Route
            path="/*"
            element={
              <MainLayout>
                <Dashboard />
              </MainLayout>
            }
          />

          <Route
            path="/myprofile"
            element={
              <MainLayout>
                <Profile activeTab="details" />
              </MainLayout>
            }
          />

          <Route
            path="/security"
            element={
              <MainLayout>
                <Profile activeTab="security" />
              </MainLayout>
            }
          />

          <Route
            path="/view-event/:eventId"
            element={
              <EventSharing />
            }
          />

          <Route path="/zoom/callback" element={<ZoomCallback />} />
           <Route path="/google/callback" element={<GoogleCallback />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;
